import { c as _c } from "react/compiler-runtime";
import { useChatMessages } from '@ai-sdk-tools/store';
import { useMemo } from 'react';
import { useAttachments } from './attachments-provider';
import type { UIMessageWithMetadata } from '../../../../lib/types';

/**
 * Component that displays a warning when files are attached.
 * Should be rendered below the chat input toolbar.
 */
export function WebSearchWarning() {
  const $ = _c(1);
  const {
    attachments
  } = useAttachments();
  const messages = useChatMessages();
  let t0;
  t0 = attachments.length > 0 || messages.some(_temp);
  const hasAnyAttachments = t0;
  if (!hasAnyAttachments) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-steel-100 rounded-b-lg px-3 py-3"><p className="text-steel-400 text-center text-sm">Web search is disabled when a file is uploaded</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}
function _temp(msg) {
  return msg.metadata?.files && msg.metadata.files.length > 0;
}